// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAstkbptv2 } from "../../../icons/full/build/icon-astkbptv2.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AstkbptvTwoIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAstkbptv2.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AstkbptvTwoIcon.displayName = 'AstkbptvTwoIcon';
}

export default AstkbptvTwoIcon;